<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料条码" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="searchInfo.matCode" />
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="箱条码" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="searchInfo.boxBarCode" />
          </el-form-item>
        </el-col>
        <el-col :lg="7" :xl="7">
          <el-form-item label="时间范围" size="small">
            <el-date-picker
              v-model="searchInfo.dateDaterange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="dateDaterangeChange"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="queryData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="箱物料绑定记录报表">
        <el-button
          v-authority="'BACK_MENU7_M7_B1'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
        >
          导出EXCEL
        </el-button>
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="queryData"
        :data="mainData"
        pagination
        :nowPage.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total.sync="pagination.total"
      >
        <el-table-column prop="matCode" label="物料条码" />
        <el-table-column prop="boxBarcode" label="箱条码" />
        <el-table-column prop="personName" label="姓名" />
        <el-table-column prop="personNumber" label="工号" />
        <el-table-column prop="createTime" label="录入时间" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              style="font-size: 14px"
              class="btn-t-delete"
              type="danger"
              icon="el-icon-delete"
              @click="deleteData(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </h-table>
    </box>
  </div>
</template>

<script>
export default {
  name: "MaterialBindingRecord",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      searchInfo: {
        dateDaterange: [],
        beginDate: "",
        endDate: "",
        matCode: "",
        boxBarCode: ""
      },
      downloadLoading: false, //下载中
      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null
    };
  },
  watch: {
    searchInfo: {
      handler() {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.queryData();
        }, 1000);
      },
      deep: true
    }
  },
  methods: {
    //获取数据
    queryData() {
      this.$http
        .request({
          url: "/api/prodScanMat/getProdScanMatLog",
          method: "GET",
          params: {
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
            beginDate: this.searchInfo.beginDate || null,
            endDate: this.searchInfo.endDate || null,
            matCode: this.searchInfo.matCode || null,
            boxBarcode: this.searchInfo.boxBarCode || null
          }
        })
        .then(resp => {
          this.loading--;
          if (resp.status === 100) {
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
        })
        .catch(() => {
          this.loading--;
        });
    },
    dateDaterangeChange(list) {
      if (list) {
        const [beginDate, endDate] = list;
        this.searchInfo.beginDate = beginDate;
        this.searchInfo.endDate = endDate;
      } else {
        this.searchInfo.beginDate = "";
        this.searchInfo.endDate = "";
        this.searchInfo.dateDaterange = [];
      }
    },
    // 重置
    resetData() {
      this.searchInfo = {
        beginDate: "",
        endDate: "",
        matCode: "",
        boxBarCode: ""
      };
      this.pagination.pageNum = 1;
    },
    deleteData(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        showClose: false
      })
        .then(async () => {
          try {
            const res = await this.$http.request({
              url: "/api/prodScanMat/deleteProdScanMatLog",
              method: "POST",
              params: { psId: row.psId }
            });
            const { status } = res;
            if (status === 100) {
              this.$message.success("删除成功");
              this.queryData();
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    // 表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        beginDate: this.searchInfo.beginDate || null,
        endDate: this.searchInfo.endDate || null,
        matCode: this.searchInfo.matCode || null,
        boxBarcode: this.searchInfo.boxBarCode || null,
        pageNum: 1,
        pageSize: 999999
      };
      this.$http
        .request({
          url: "/api/prodScanMat/exportProdScanMatLog",
          method: "GET",
          showLoading: true,
          params: paramsObj
        })
        .then(resp => {
          resp.status === 100
            ? this.downLoad(resp.data || [])
            : this.$notify.error({ message: "查询失败" });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then(excel => {
        const tHeader = ["翻箱条码", "箱条码", "操作人", "创建时间"];
        const filterVal = ["matCode", "boxBarcode", "personName", "createTime"];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "导出箱物料绑定记录报表数据"
        });
        this.logContent = "导出";
        this.logRemarks = "wh_inventory_safety：导出箱物料绑定记录报表数据";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "箱物料绑定记录查询",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || ""
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData
        })
        .then(() => {
          this.logContent = "";
          this.logRemarks = "";
        })
        .catch(() => {});
    }
  },
  activated() {
    this.queryData();
  }
};
</script>

<style scoped></style>
